import {RequestDetailsComponent} from './request-details/request-details.component';
import {RoleGuard} from '../../services/guards/role-guard.service';
import {MainMenuComponent} from './main-menu/main-menu.component';
import {NotFoundComponent} from '../not-found/not-found.component';
import {BasicInformationComponent} from './basic-information/basic-information.component';
import {NewRequestConfirmComponent} from './new-request-confirm/new-request-confirm.component';
import {OfferComponent} from './offer/offer.component';
import {NotesComponent} from '../notes/notes.component';


export const individualAccidentsRoutes = [
  {
    path: 'individual-accidents',
    children: [
      {
        path: 'details',
        component: RequestDetailsComponent,
        canActivate: [RoleGuard],
        data: {role: 'user'}
      },
      {
        path: '',
        component: MainMenuComponent
      },
      {
        path: 'basic-information',
        component: BasicInformationComponent
      },
      {
        path: 'offers',
        component: OfferComponent
      },
      {
        path: 'confirm',
        component: NewRequestConfirmComponent
      },
      {
        path: 'notes',
        component: NotesComponent
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];
